import { render, staticRenderFns } from "./EnrolmentProjectionList.vue?vue&type=template&id=dc490ff6"
import script from "./EnrolmentProjectionList.vue?vue&type=script&lang=js"
export * from "./EnrolmentProjectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports